import axios from 'axios'
import {
  Message
} from 'element-ui'
// 请求拦截
axios.interceptors.request.use(function (request) {
  // 处理请求之前的配置 token
  request.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
  request.headers['content-type'] = 'application/json'
  return request
}, function (error) {
  // 请求失败的处理
  return Promise.reject(error)
})

// 响应拦截
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    if (err.response.status) {
      switch (err.response.status) {
        case 403:
          Message({
            type: 'error',
            message: '资源不可用'
          })
          window.location.href = '/login'
          window.localStorage.clear()
          break
        case 401:
          Message({
            type: 'error',
            message: '未授权'
          })
          window.location.href = '/login'
          window.localStorage.clear()
          break
        case 537:
          Message({
            type: 'error',
            message: '系统错误'
          })
          window.location.href = '/login'
          window.localStorage.clear()
          break
        default:
          console.log('请求信息:', err.response)
          break
      }
    }
    return err.response
  })
export default axios
/**
 * curl -X POST "https://api.singschool.cn/api/upload/file" -H "accept: application/json" -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIyN2FjNjY0OS0xMTFhLTQyNjMtOWViOC1kNTk3OTMwM2FiZmUiLCJwcmltYXJ5c2lkIjoib0RTRXB0NG1vbXZyVXE0ZGFoalY1a09kR251NCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6IjNiMmI3MmVkLWQzNDQtNDIzMi04MWRhLWJhYjJjZjgyNzc0YyIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3Bvc3RhbGNvZGUiOiJXRUNIQVQiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2V4cGlyYXRpb24iOiIyMDIyLzEyLzEyIDk6Mzg6MTMiLCJuYmYiOjE1ODQ0Mzc4OTMsImV4cCI6MTY3MDgzNzg5MywiaWF0IjoxNTg0NDM3ODkzLCJpc3MiOiJodHRwczovL3NpbmdjaGluYS5jb20iLCJhdWQiOiJodHRwczovL3NpbmdjaGluYS5jb20ifQ.YGEJtlpd6bV_GBR5jkBAM_D3OlPY3eoLNc0h-_Zz43Q" -H "Content-Type: multipart/form-data" -F "file=@音乐.mp3;type=audio/mp3"
 */



// WEBPACK FOOTER //
// ./src/utils/request.js